import {
    GET_DATAENTRY_PLANTS_SUCCESS,
    GET_DATAENTRY_PLANTS_FAIL,
    GET_DATAENTRY_ANIMALS_SUCCESS,
    GET_DATAENTRY_ANIMALS_FAIL,
    ADD_DATAENTRY_PLANT_SUCCESS,
    ADD_DATAENTRY_PLANT_FAIL,
    ADD_DATAENTRY_ANIMAL_SUCCESS,
    ADD_DATAENTRY_ANIMAL_FAIL,
    GET_LEADERBOARD_SUCCESS,
    GET_LEADERBOARD_FAIL
} from "./actionTypes"

const INIT_STATE = {
  plants: [],
  animals: [],
  error: {},
  leaderboard: [],
}

const hackathon  = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DATAENTRY_PLANTS_SUCCESS:
      return {
        ...state,
        plants: action.payload,
      }

    case GET_DATAENTRY_PLANTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DATAENTRY_ANIMALS_SUCCESS:
      return {
        ...state,
        animals: action.payload,
      }

    case ADD_DATAENTRY_PLANT_SUCCESS:
      return {
	...state,
      }

    case ADD_DATAENTRY_PLANT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_DATAENTRY_ANIMAL_SUCCESS:
      return {
        ...state,
      }

    case ADD_DATAENTRY_ANIMAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
 
    case GET_LEADERBOARD_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_LEADERBOARD_SUCCESS:
      return {
        ...state,
        leaderboard: action.payload,
      }

    default:
      return state
  }
}

export default hackathon 
